<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="glo"><span class="epub-bi">Glossary of Terms</span></p>
<p class="gl"><span class="epub-i">Aktions</span> – The removal of Jews, Gypsies and other ‘enemies’ of the Third Reich to the concentration camps.</p>
<p class="gl"><span class="epub-i">Aliyah Bet</span> – The codename given to the illegal immigration of Jews to Palestine in the 1930s and 40s.</p>
<p class="gl"><span class="epub-i">Appell</span> – Roll-call at the camps.</p>
<p class="gl"><span class="epub-i">Appellplatz</span> – The square where prisoners would assemble for roll-call.</p>
<p class="gl"><span class="epub-i">Arschlöcher</span> – German insult; arsehole.</p>
<p class="gl"><span class="epub-i">Asos</span> – Short for ‘antisocial ones’ – a category of prisoners including the homeless, long-term unemployed, sex offenders etc.</p>
<p class="gl"><span class="epub-i">Baumeisters</span> – Civilian engineers (see also <span class="epub-i">Steigers</span>).</p>
<p class="gl">Bedzin – Author’s home town.</p>
<p class="gl">Berchtesgaden – Hitler’s Bavarian retreat.</p>
<p class="gl"><span class="epub-i">Berufsverbrecher</span> – Professional criminals who worked in the camps.</p>
<p class="gl"><span class="epub-i">Blockältester</span> – Block senior.</p>
<p class="gl"><span class="epub-i">Blockschreiber</span> – Roll-call clerk.</p>
<p class="gl"><span class="epub-i">Blocksperre</span> – Lock-down.</p>
<p class="gl">Byelorussia – Belarus.</p>
<p class="gl"><span class="epub-i">Dreckjuden!</span> – German insult; ‘Dirt Jew!’</p>
<p class="gl"><span class="epub-i">Edelweiss Piraten</span> – Anti-Nazi movement in Germany.</p>
<p class="gl"><span class="epub-i">Einsatzgruppe</span> – German taskforce, execution squad.</p>
<p class="gl"><span class="epub-i">Eretz Yisrael</span> – The Biblical Land of Israel; Greater Israel.</p>
<p class="gl"><span class="epub-i">Fall Weiss</span> – The Nazi’s strategic plan for invading Poland.</p>
<p class="gl"><span class="epub-i">Familienlager</span> – Family camp.</p>
<p class="gl"><span class="epub-i">Gau</span> – German district.</p>
<p class="gl"><span class="epub-i">Gauleiter</span> – District leader.</p>
<p class="gl"><span class="epub-i">Gordonia</span> – A Zionist youth movement.</p>
<p class="gl"><span class="epub-i">Hachshara</span> – Preparation for emigration to Palestine/Israel.</p>
<p class="gl"><span class="epub-i">Häftlingskrankenbau</span> – Prisoners’ hospital.</p>
<p class="gl">Haganah – Jewish Defence Force; paramilitary organisation.</p>
<p class="gl"><span class="epub-i">Hausfrau</span> – Housewife.</p>
<p class="gl"><span class="epub-i">Heder</span> – Religious primary school.</p>
<p class="gl"><span class="epub-i">Hefker</span> – Jewish term for being free of responsibilities; from the legal term to denote an ownerless property.</p>
<p class="gl"><span class="epub-i">Hitlerjugend</span> – Hitler Youth.</p>
<p class="gl"><span class="epub-i">Jedem das Seine</span> – ‘To each, his own’ – motto on gates of Mauthausen camp.</p>
<p class="gl"><span class="epub-i">Judenfieber</span> – Typhus; lit. ‘Jew fever’.</p>
<p class="gl"><span class="epub-i">Judenrat</span> – Jewish council.</p>
<p class="gl"><span class="epub-i">Judenrein</span> – Cleansed of Jews.</p>
<p class="gl"><span class="epub-i">Kaddish</span> – Jewish prayer for the dead.</p>
<p class="gl"><span class="epub-i">Kapos</span> – Camp foremen, recruited from the ranks of the prisoners.</p>
<p class="gl"><span class="epub-i">Kappellmeister</span> – Bandmaster.</p>
<p class="gl"><span class="epub-i">Kindertransporte</span> – The transport of children – either to safety, or to the death camps.</p>
<p class="gl"><span class="epub-i">Knochenmühle</span> – ‘The bone-grinder’ – nickname for Mauthausen camp.</p>
<p class="gl"><span class="epub-i">Kojen</span> – Three-tiered bunk.</p>
<p class="gl"><span class="epub-i">Kommando</span> – German term for unit.</p>
<p class="gl"><span class="epub-i">Kriegsmarine</span> – German Navy.</p>
<p class="gl"><span class="epub-i">Lagerälteste</span> – Camp seniors.</p>
<p class="gl"><span class="epub-i">Lagerführer</span> – Camp commandant.</p>
<p class="gl"><span class="epub-i">Lagerschreiber</span> – Camp clerk.</p>
<p class="gl"><span class="epub-i">Lausbub</span> – German insult; rascal.</p>
<p class="gl"><span class="epub-i">Lebensraum</span> – Literally, living space, Hitler’s foreign policy for expanding the Reich.</p>
<p class="gl"><span class="epub-i">Machal</span> – The Hebrew acronym for ‘Overseas Volunteers’; soldiers who fought for the new state of Israel.</p>
<p class="gl"><span class="epub-i">Maurerschule</span> – Builders’ school.</p>
<p class="gl"><span class="epub-i">Muselmänner</span> – Muslims (col. for starving camp inmates).</p>
<p class="gl"><span class="epub-i">Oberkapo</span> – Chief <span class="epub-i">Kapo.</span></p>
<p class="gl"><span class="epub-i">Operation Barbarossa</span> – Codename for German invasion of Russia.</p>
<p class="gl"><span class="epub-i">Organisation</span> – Slang for black market operations in the camps.</p>
<p class="gl"><span class="epub-i">Piepels</span> – Boys used for sex by camp guards and <span class="epub-i">Kapos.</span></p>
<p class="gl"><span class="epub-i">Premiumschein</span> – Ticket for canteen.</p>
<p class="gl"><span class="epub-i">Rampe Kommando</span> – Platform detachment.</p>
<p class="gl"><span class="epub-i">Rapportführer</span> – Sergeant Major, commander of Block.</p>
<p class="gl"><span class="epub-i">Raus!</span> – Out!</p>
<p class="gl"><span class="epub-i">Reichsfeldmarschall</span> – German rank of Field Marshal.</p>
<p class="gl"><span class="epub-i">Rottenführer</span> – Nazi Party section leader.</p>
<p class="gl"><span class="epub-i">Scheissjude</span> – Racial insult (lit. ‘shit-Jew’).</p>
<p class="gl"><span class="epub-i">Schiffchen</span> – Soft side-cap.</p>
<p class="gl"><span class="epub-i">Schnell!</span> – Quickly!</p>
<p class="gl"><span class="epub-i">Schutzhäftlinge</span> – Political prisoners (lit. protective prisoners).</p>
<p class="gl"><span class="epub-i">Shabbat</span> – Jewish Sabbath.</p>
<p class="gl"><span class="epub-i">Sheitel</span> – Traditional black wig worn by Jewish women.</p>
<p class="gl"><span class="epub-i">Shem Yisborach</span> – Hebrew name for God.</p>
<p class="gl"><span class="epub-i">Sicherheitsdienst</span> – German security service.</p>
<p class="gl"><span class="epub-i">Smetana</span> – Sour cream.</p>
<p class="gl"><span class="epub-i">Sonderausweis</span> – Passes that stated you were essential to the war effort.</p>
<p class="gl"><span class="epub-i">Sonderbehandlung</span> – Special treatment.</p>
<p class="gl"><span class="epub-i">Sonderkommando</span> – Special units; inmates who were forced to operate the gas chambers and crematoria.</p>
<p class="gl"><span class="epub-i">Stahlhelmes</span> – Steel helmets.</p>
<p class="gl"><span class="epub-i">Stalags</span> – Prisoner-of-war camp.</p>
<p class="gl"><span class="epub-i">Steigers</span> – Civilian engineers (see also <span class="epub-i">Baumeisters</span>).</p>
<p class="gl"><span class="epub-i">Stiebel</span> – Jewish prayer room.</p>
<p class="gl"><span class="epub-i">Stube</span> – Side room.</p>
<p class="gl"><span class="epub-i">Stubendienst</span> – Camp orderlies.</p>
<p class="gl"><span class="epub-i">Sturmabteilung</span> – Brown Shirts.</p>
<p class="gl"><span class="epub-i">Sturmbrigade Dirlewanger</span> – Notorious SS military unit composed of German prisoners.</p>
<p class="gl"><span class="epub-i">Totenkopf</span> – Death’s Head units of SS.</p>
<p class="gl"><span class="epub-i">Treif</span> – Non-kosher food.</p>
<p class="gl"><span class="epub-i">Treuhänder</span> – A trusty; trusted helper.</p>
<p class="gl"><span class="epub-i">Umgeseidelt im Osten</span> – Resettlement in the East.</p>
<p class="gl"><span class="epub-i">Untermenschen</span> – Literally, subhuman. A Nazi term for Jews.</p>
<p class="gl"><span class="epub-i">Unteroffizier/Unterscharführer</span> – Corporal (Army/SS).</p>
<p class="gl"><span class="epub-i">Volksdeutsche</span> – Poles of German origin.</p>
<p class="gl"><span class="epub-i">Vorarbeiter</span> – Foreman.</p>
<p class="gl"><span class="epub-i">Wehrmacht</span> – Germany’s armed forces.</p>
<p class="gl"><span class="epub-i">Winterhilfe</span> – Contributions to help soldiers on the Eastern Front.</p>
<p class="gl">Yad Vashem – Holocaust History Museum in Jerusalem.</p>
<p class="gl"><span class="epub-i">Yiddishkeit</span> – Jewishness.</p>
<p class="gl">Zyklon B – Chemical compound used in the gas chambers.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// glossary.vue?43eb1586